// extracted by mini-css-extract-plugin
export default {"adminPanel":"AdminPanel_adminPanel__UuVfH","sidebar":"AdminPanel_sidebar__2DcoH","active":"AdminPanel_active__SaXPR","content":"AdminPanel_content__6PWcp"};